
import { UPDATE_SEARCHDATA_GOIVAY } from "actions/QuanLyGoiVay/actionTypes";
const initialState = {
  sSearch:"",
  iPageIndex: 1,
  iPageSize: 20
};
const updateDataSearch = (state, action) => ({
  ...action.payload,
});

export const dataSearchGoiVay = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHDATA_GOIVAY:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchGoiVay;
